/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Debtor_PersonInputs */

const en_case_debtor_person = /** @type {(inputs: Case_Debtor_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individual`)
};

const pt_br2_case_debtor_person = /** @type {(inputs: Case_Debtor_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pessoa física`)
};

/**
* | output |
* | --- |
* | "Individual" |
*
* @param {Case_Debtor_PersonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_debtor_person = /** @type {((inputs?: Case_Debtor_PersonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Debtor_PersonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_debtor_person(inputs)
	return pt_br2_case_debtor_person(inputs)
});